import { Button, Box, Grid, Modal } from "@mui/material";
import { useState } from "react";
import { useCreateWeavingAlert } from "../../../../hooks/weaving_alert/use-create-weaving-alert";
import AutoSelectProductLoaded from "../../../../containers/selects/autoselect-product-loaded";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};

const ModalCreateAlert = () => {

    const [openModal, setOpenModal] = useState(false);

    const createWeavingAlert = useCreateWeavingAlert();

    const handleOpen = () => {
        setOpenModal(true);
    }

    const handleClose = () => {
        setOpenModal(false);
    }

    return (
        <div>
            <Button variant="contained" onClick={handleOpen}>
                Crear alerta tejeduría
            </Button>
            <Modal
            open={openModal}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} lg={12}>
                            <div style={{ margin: '5px 0' }}>
                                <AutoSelectProductLoaded 
                                    onChange={(value) => {
                                        createWeavingAlert.setEntity({
                                            ...createWeavingAlert.entity,
                                            product: value
                                        })
                                    }}
                                />
                            </div>
                            <Button variant="contained" onClick={() => createWeavingAlert.create()}>
                                Crear alerta
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </div>
    )
}

export default ModalCreateAlert;
